<template>
    <multiselect :allow-empty="false" :disabled="disabled"
                 :loading="isLoading"
                 :max-height="600"
                 :multiple="true"
                 :options="items"
                 :required="required"
                 :searchable="true"
                 deselect-label="Remover seleção"
                 label="name"
                 placeholder="Selecione uma ou mais opções"
                 select-label="Selecionar"
                 track-by="name"
                 v-model="value"
    ></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        components: {Multiselect},
        props: ['required', 'disabled', 'value'],
        name: "Cid10",
        data() {
            return {
                items: [],
                isLoading: true
            }
        },
        watch: {
            value: function (variable, var2) {
                this.$emit('input', this.value);
            }
        },
        mounted() {
            if (!this.disabled) {
                axios.get('/cid10').then(r => {
                    this.items = r.data;
                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }

        },
        methods: {
            asyncFind(query) {
                debugger;
            },
            limitText(count) {
                return `and ${count} other countries`
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FormBuilder/Fields/Cid10.vue